import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { withConfig } from 'src/withConfig';



interface SportMeetingsListPropsType {

    variant: DefaultComponentVariantType | null;

}



const setRaceResultsWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            margin: 0 0 8px;

            @media ${theme.star.mediaQuery.tablet} {

                border-radius: 0 0 ${theme.star.radius.medium} ${theme.star.radius.medium};

                margin: 0 8px 8px;

            }

            overflow: hidden;

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.medium};

        `;

    }

    return css``;

};





export const SportMeetingsListWrapper = withConfig(theme => styled('div', { label: 'SportMeetingsListWrapper' })<SportMeetingsListPropsType>`

    ${({ variant }): SerializedStyles=> setRaceResultsWrapper(variant, theme)};

    background-color: ${theme.star.meetingsListColors.bgColor};

`);



const setSportMeetingsFiltersWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            margin: 0 8px;

            @media ${theme.star.mediaQuery.mobile} {

                padding: 8px 0;

            }

            @media ${theme.star.mediaQuery.tablet} {

                margin: 0;

            }

        `;

    }

    return css`

        border: 1px solid ${theme.star.filtersColors.wrapper.borderColor};

    `;

};



export const SportMeetingsFiltersWrapper = withConfig(theme => styled('div', { label: 'SportMeetingsFiltersWrapper' })<SportMeetingsListPropsType>`

    ${({ variant }): SerializedStyles=> setSportMeetingsFiltersWrapper(variant, theme)};

    padding: 8px 0 8px 8px;

`);

